import { createDuck, createEntityCollection } from '@/utils'
import { getCouponData, awardCoupon } from '@/services/api/common'
import { Toast } from 'antd-mobile-v2'
const SHOP_ID = 1
export const duck = createDuck({
  name: 'couponDuck',
  initialState: {
    coupons: [],
    entities: {},
  },
  actions: {
    fetchCouponData(itemId) {
      return async dispatch => {
        const { data, error } = await getCouponData(itemId, SHOP_ID)
        if (!error) {
          const _d = Array.isArray(data) ? data : []
          const col = createEntityCollection(_d, item => item.couponId)
          dispatch(
            duck.change({
              coupons: col.list,
              entities: col.entities,
            }),
          )
        }
      }
    },

    /**
     * 领券
     * @param {number} couponId
     */
    awardCouponById(couponId) {
      return async (dispatch, getState) => {
        const { couponDuck } = getState()
        const { error } = await awardCoupon(couponId, SHOP_ID)
        if (!error) {
          Toast.info('领取成功')
          dispatch(
            duck.merge({
              entities: {
                [couponId]: {
                  ...couponDuck.entities[couponId],
                  userHasCoupon: true,
                },
              },
            }),
          )
        } else {
          Toast.fail(error.message || '领券失败')
        }
      }
    },
  },
})
